import React from 'react'
import ReactDOM from 'react-dom'

import Root, { store } from './main'
import './styles/normalize.css'
import './styles/app.css'
import './styles/variables.css'

ReactDOM.render(<Root store={ store } />, document.getElementById('root'))
